import { hasAuth0Config } from '../../shared/config/env';
import { useAuthSync } from '../../features/auth/hooks/useAuthSync';

const authEnabled = hasAuth0Config();

function AuthSessionSyncEnabled() {
  useAuthSync();
  return null;
}

export function AuthSessionSync() {
  if (!authEnabled) {
    return null;
  }

  return <AuthSessionSyncEnabled />;
}
